import { motion, useReducedMotion } from "framer-motion";
import { Check } from "lucide-react";
import { EASE, Eyebrow } from "../Reveal";
import { LuxButton } from "../LuxButton";
import { useUI } from "@/context/UIContext";
import { IMG } from "@/lib/images";

const BENEFITS = [
  "Request management at your fingertips",
  "Real-time updates on every service",
  "Seamless communication with your team",
];

export const ConciergeCard = () => {
  const { openEnquiry } = useUI();
  const reduced = useReducedMotion();

  return (
    <section
      data-testid="concierge-section"
      className="mx-auto max-w-[1280px] scroll-mt-24 px-5 py-24 md:py-32 lg:px-12"
    >
      <div className="grid overflow-hidden rounded-[4px] border border-[rgba(200,164,93,0.35)] bg-noir-card shadow-[0_10px_40px_rgba(177,138,68,0.08)] md:grid-cols-2">
        <motion.div
          className="flex flex-col justify-center p-8 sm:p-12 lg:p-16"
          initial={{ opacity: 0, x: reduced ? 0 : -25 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.85, ease: EASE }}
        >
          <Eyebrow>Concierge</Eyebrow>
          <h2 className="mt-6 font-serif text-[34px] font-medium leading-[1.1] text-ivory sm:text-4xl lg:text-[44px]">
            Your concierge,
            <br />
            anywhere
          </h2>
          <p className="mt-6 max-w-md text-sm font-light leading-relaxed text-ivory-muted">
            Manage requests, explore exclusive access, and stay connected wherever
            you are. Everything you need in one place.
          </p>
          <ul className="mt-8 space-y-3.5">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-3.5 text-[13px] font-light text-ivory-muted">
                <Check className="mt-[3px] h-3.5 w-3.5 shrink-0 text-champagne" strokeWidth={2} />
                {b}
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <LuxButton to="/concierge" testId="concierge-explore-button">
              Explore
            </LuxButton>
            <LuxButton
              variant="text"
              arrow
              onClick={() => openEnquiry("Concierge")}
              testId="concierge-learn-more-button"
            >
              Learn More
            </LuxButton>
          </div>
        </motion.div>

        <motion.div
          className="relative aspect-[4/5] overflow-hidden sm:aspect-square md:aspect-auto md:min-h-[520px]"
          initial={{ opacity: 0, x: reduced ? 0 : 25 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.85, ease: EASE }}
          data-cursor
        >
          <motion.img
            src={IMG.chauffeur}
            alt="MDS Arabama chauffeur standing beside a black Mercedes E-Class"
            loading="lazy"
            whileHover={reduced ? {} : { scale: 1.025 }}
            transition={{ duration: 0.8, ease: EASE }}
            className="img-lux-grade absolute inset-0 h-full w-full object-cover object-right md:object-[85%_center]"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-noir-card/50 via-transparent to-transparent" />
        </motion.div>
      </div>
    </section>
  );
};
